const AddToCartIcon = ({
  style = { height: "2.5vh", width: "2.5vh" },
  color = "white",
}) => {
  return (
    <svg
      height="100%"
      width="100%"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="m22.75 6c0 .41-.34.75-.75.75h-2.25v2.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.25h-2.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.25v-2.25c0-.41.34-.75.75-.75s.75.34.75.75v2.25h2.25c.41 0 .75.34.75.75zm0 14c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75c0-.45.12-.87.31-1.25h-7.12c.19.38.31.8.31 1.25 0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75c0-1.14.7-2.12 1.7-2.54l-1.53-13c-.06-.51-.44-.94-.94-1.07l-2.66-.66c-.4-.1-.65-.51-.55-.91s.5-.65.91-.55l2.66.67c1.1.27 1.93 1.22 2.07 2.34l.11.99s.08-.02.12-.02h6.67c-.04.25-.06.5-.06.75 0 2.89 2.36 5.25 5.25 5.25 1.28 0 2.46-.47 3.38-1.23l-.42 3.18c-.11.81-.78 1.45-1.6 1.51l-12.12.96.19 1.58h11.57c1.52 0 2.75 1.23 2.75 2.75zm-13.5 0c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25.56 1.25 1.25 1.25 1.25-.56 1.25-1.25zm12 0c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25.56 1.25 1.25 1.25 1.25-.56 1.25-1.25z"
        fill={color && color}
      />
    </svg>
  );
};

export default AddToCartIcon;
